import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ListErrorsComponent } from './list-errors/list-errors.component';
import { ShowAuthedDirective } from './show-authed.directive';
import { ContentPreloadComponent } from './layout/content-preload/content-preload.component';
import { SelectPipe } from './select.pipe';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { UserGroupDirective } from './user-group.directive';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';

const MODULES_TO_EXPORT: any[] = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    BsDropdownModule,
    ModalModule,
];

const DECLARATIONS_TO_EXPORT: any[] = [
    ListErrorsComponent,
    ShowAuthedDirective,
    UserGroupDirective,
    ContentPreloadComponent,
    SelectPipe,
    NavbarComponent,
    FooterComponent,
];

@NgModule({
    imports: MODULES_TO_EXPORT,
    exports: [...MODULES_TO_EXPORT, ...DECLARATIONS_TO_EXPORT],
    declarations: DECLARATIONS_TO_EXPORT,
})
export class SharedModule {}
